export default __webpack_public_path__ + "static/media/logo.f8f5e222.png";